import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    
    <footer>
      <p> Fadayo Copyright ⓒ {year}</p>
    </footer>
  );
}

export default Footer;
